import axios from 'axios';
import { DownloadResult } from './downloadResult';
import UploadResource from './resource';

export const List = (signal?: AbortSignal) => axios.get<UploadResource[]>('/api/Uploads', { signal });
export const ListByToken = (token: string, signal?: AbortSignal) => axios.get<UploadResource[]>(`/api/Uploads/${token}`, { signal });

export const Download = async (
  id: number,
  password: string,
  signal?: AbortSignal,
): Promise<DownloadResult> => {
  const response = await axios.post<Blob>(
    `/api/Uploads/${id}/Download`,
    { password },
    { signal, responseType: 'blob' },
  );
  const fileAttr = response.headers['content-disposition'].split('filename=')[1];
  const fileName = fileAttr.substring(0, fileAttr.indexOf(';'));

  console.log(fileName);

  // const data = new Blob([response.data], { type: 'application/octet-stream' });
  const { data } = response;

  return { data, fileName };
};

export const Upload = (data: FormData, token: string, signal?: AbortSignal) => axios.post(`/api/Uploads?token=${token}`, data, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  signal,
});

export const Delete = (id: number, signal?: AbortSignal) => axios.delete(`/api/Uploads/${id}`, { signal });
